import { Formik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
  attPreSinAnt,
  attPregestacionalOpt,
  noAplicaOpt,
  noSiOpt,
  opt123,
  primeraVezSubsecuentaOpt,
  inicialSubsecuentaOpt,
  sintomaDepresivaOpt,
} from "./constants/options";
import Controller from "./controller/Controller";
import { Fragment, useContext, useState,useEffect } from "react";
import * as Yup from "yup";
import Post from "../../../api/Post";
import { MEDICAL_HISTORY_MX } from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import Put from "../../../api/Put";
import SimpleLoad from "../../../loader/SimpleLoad";
import Get from "../../../api/Get";
const fields1 = [
  {
    name: "sintomaDepresiva",
    type: "select",
    label: "Consulta Depresión adulto mayor",
    options: [...noAplicaOpt, ...sintomaDepresivaOpt],
  },
  {
    name: "alteracionMemoria",
    type: "select",
    label: "Consulta Alteración memoria",
    options: [...noAplicaOpt, ...sintomaDepresivaOpt],
  },
  {
    name: "aivdABVD",
    type: "select",
    label: "Consulta aivd-ABVD",
    options: [...noAplicaOpt, ...sintomaDepresivaOpt],
  },
  {
    name: "sindromeCaidas",
    type: "select",
    label: "Consulta por Caidas",
    options: [...noAplicaOpt, ...sintomaDepresivaOpt],
  },
 
];

const fields2 = [
  {
    name: "incontinenciaUrinaria",
    type: "select",
    label: "Consulta por Incontinencia Urinaria",
    options: [...noAplicaOpt, ...sintomaDepresivaOpt],
  },
  {
    name: "motricidad",
    type: "select",
    label: "Consulta por Motricidad",
    options: [...noAplicaOpt, ...sintomaDepresivaOpt],
  },
  {
    name: "asesoriaNutricional",
    type: "select",
    label: "Consulta por Asesoria Nutricional",
    options: [...noAplicaOpt, ...sintomaDepresivaOpt],
  },
];

export default function GerontologicalMex({
  setShowModalServer,
  setErrorServer,
  setShowSuccess,
  citaId,
  gerontological = null,
  validationData,
}) {
  const { auth } = useContext(authContext);
  const [isSubmiting, setSubmiting] = useState(false);
  const [id, setId] = useState(null);
  const schema = Yup.object().shape({
    sintomaDepresiva: Yup.number().test(
      'sintomaDepresiva',
      'Valor inválido',
      function (value) {
        const { tipoPersonal } = validationData;
        if (tipoPersonal == 25) {
          return value == 1 || value == 2;
        } else {
          return value == -1;
        }
      }
    ),
    alteracionMemoria: Yup.number().test(
      'alteracionMemoria',
      'Valor inválido',
      function (value) {
        const { tipoPersonal } = validationData;
        if (tipoPersonal == 25) {
          return value == 1 || value == 2;
        } else {
          return value == -1;
        }
      }
    ),
    aivdABVD: Yup.number().test(
      'aivdABVD',
      'Valor inválido',
      function (value) {
        const { tipoPersonal } = validationData;
        if (tipoPersonal == 25) {
          return value == 1 || value == 2;
        } else {
          return value == -1;
        }
      }
    ),
    sindromeCaidas: Yup.number().test(
      'sindromeCaidas',
      'Valor inválido',
      function (value) {
        const { tipoPersonal } = validationData;
        if (tipoPersonal == 25) {
          return value == 1 || value == 2;
        } else {
          return value == -1;
        }
      }
    ),
    incontinenciaUrinaria: Yup.number().test(
      'incontinenciaUrinaria',
      'Valor inválido',
      function (value) {
        const { tipoPersonal } = validationData;
        if (tipoPersonal == 25) {
          return value == 1 || value == 2;
        } else {
          return value == -1;
        }
      }
    ),
    motricidad: Yup.number().test(
      'motricidad',
      'Valor inválido',
      function (value) {
        const { tipoPersonal } = validationData;
        if (tipoPersonal == 25) {
          return value == 1 || value == 2;
        } else {
          return value == -1;
        }
      }
    ),
    asesoriaNutricional: Yup.number().test(
      'asesoriaNutricional',
      'Valor inválido',
      function (value) {
        const { tipoPersonal } = validationData;
        if (tipoPersonal == 25) {
          return value == 1 || value == 2;
        } else {
          return value == -1;
        }
      }
    ),
  });
  const [initValues, setInitValues] = useState(gerontological);
  
  useEffect(() => {
    if (initValues?.id) {
      setSubmiting(true);
      Get({
        url: `${MEDICAL_HISTORY_MX}/find-gerontological/${initValues.id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setInitValues(response.data);
          setSubmiting(false);
        })
        .catch((error) => {
          console.log(error);
          setSubmiting(false);
        });
    }
  }, [initValues?.id, auth.data.access_token]);
  return (
    <>
      <Formik
        initialValues={ initValues
          ? initValues
          :{
          appointmentId: citaId,
          sintomaDepresiva: "-1",
          alteracionMemoria: "-1",
          aivdABVD: "-1",
          sindromeCaidas: "-1",
          incontinenciaUrinaria: "-1",
          motricidad: "-1",
          asesoriaNutricional: "-1",
          
        }}
        validationSchema={schema}
        enableReinitialize
        onSubmit={async (values, { setSubmitting, setFieldValue }) => {
          setSubmiting(true);
          if (id) {
            const body = {
              id,
              ...values,
            };
            try {
              const response = await Put({
                url: `${MEDICAL_HISTORY_MX}/update-gerontological/`,
                data: body,
                access_token: auth.data.access_token,
                header: true,
              });
              console.log(response);
              setSubmiting(false);
              setTimeout(() => {
                setShowSuccess(false);
              }, 2000);
            } catch (error) {}
          } else {
            try {
              const response = await Post({
                url: `${MEDICAL_HISTORY_MX}/save-gerontological/`,
                data: values,
                access_token: auth.data.access_token,
                header: true,
              });
              console.log(response);
              setId(response.data.id);
              setSubmiting(false);
              setTimeout(() => {
                setShowSuccess(false);
              }, 2000);
            } catch (error) {
              setSubmiting(false);
              setShowModalServer(true);
              if (error.response) {
                setErrorServer(error.response);
              }
            }
          }
          console.log(values);
        }}
      >
        {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            {isSubmiting && <SimpleLoad />}
            <Row>
              <Col xs="12" md="6">
                <dl className="row">
                  {fields1.map((it) => (
                    <Fragment key={it.name}>
                      <dt className="col-sm-5">{it.label}</dt>
                      <dd className="col-sm-7">
                        <Controller
                          type={it.type}
                          name={it.name}
                          errors={errors}
                          onChange={handleChange}
                          options={it.options}
                        />
                      </dd>
                    </Fragment>
                  ))}
                </dl>
              </Col>
              <Col xs="12" md="6">
                <dl className="row">
                  {fields2.map((it) => (
                    <Fragment key={it.name}>
                      <dt className="col-sm-5">{it.label}</dt>
                      <dd className="col-sm-7">
                        <Controller
                          type={it.type}
                          name={it.name}
                          errors={errors}
                          onChange={handleChange}
                          options={it.options}
                        />
                      </dd>
                    </Fragment>
                  ))}
                </dl>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col className="text-right">
                <Button
                  variant="outline-success"
                  className="ok-buttom"
                  type="submit"
                >
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
}
